(function () {
    document.addEventListener('DOMContentLoaded', function () {
        
    });
})();